export const HTTP_CODE = {
  NOT_ALLOWED_IP: 5,
};
